<template>
  <v-container v-if="loading" fluid>
    <v-layout row>
      <v-progress-linear indeterminate />
    </v-layout>
  </v-container>

  <div v-else>
    <v-layout row justify-space-between align-center>
      <v-flex>
        <div class="d-inline-block ml-2">
          <span class="font-weight-bold">Active Skills:</span>
          <span v-for="(skill, i) in employeesActiveSkills" class="grey--text">
            {{ skill }} {{ (i+1 < employeesActiveSkills.length) ? ` | ` : ` ` }}
          </span>
        </div>
      </v-flex>

      <v-flex class="text-xs-right">
        <!-- TODO: abstract this to component maybe using slot for dialog or both -->
        <v-dialog v-model="newSkillDialog" max-width="290">
          <v-btn slot='activator'>
            <v-icon left>add</v-icon>
            New Skill
          </v-btn>
          <v-card>
            <v-card-title class="headline">Create New Skill</v-card-title>
            <v-card-text>
              <v-text-field label="Skill Name" v-model="skillName">
              </v-text-field>
              <!--
              <v-checkbox disabled label="Only for this user?" v-model="skillLocal">
              </v-checkbox>
              -->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" flat @click="newSkillDialog = false">Nevermind</v-btn>
              <v-btn color='success' small :loading="apiCallPending" @click="createSkill">
                Create
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span>
          <a href="#" @click.prevent="toggleDeleteSkills"><v-icon>delete</v-icon> {{ deletingSkills ? 'Stop Deleting Skills' : 'Delete Skills' }}</a>
        </span>
      </v-flex>
    </v-layout>

    <hr />

    <v-layout align-start justify-start column wrap style="height: 300px;">
      <div v-if="deletingSkills">
        <v-dialog v-model="deleteSkillDialog" max-width="290">
          <v-card>
            <v-card-title class="headline">Delete "{{ deleteDialogItem.name }}"?</v-card-title>
            <v-card-text>
              This will remove the {{ deleteDialogItem.name }} skill from the system entirely, removing it from any users to whom it is currently assigned.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" flat @click="deleteSkillDialog = false">Nevermind</v-btn>
              <v-btn color='error' small :loading="apiCallPending" @click="deleteSkill(deleteDialogItem)">
                Remove
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-for="skill in globalSkillsAvailable">
          <v-chip @click="openDeleteModal(skill)" color="red lighten-1" text-color="white" class="delete-skill" style="cursor: pointer;">
            <EmployeeSkillBox
              :label="skill.name"
              :fieldName="skill.name"
              disabled
              :object="employee"
              class="removing"
            />
            <v-icon class="ml-2" color="red lighten-4">cancel</v-icon>
          </v-chip>
        </div>
      </div>
      <div v-else>
        <v-layout row wrap justify-space-around>
          <v-flex class="mr-4" v-for="skill in globalSkillsAvailable">
            <EmployeeSkillBox
              :label="skill.name"
              :fieldName="skill.name"
              :object="employee"
            />
          </v-flex>
        </v-layout>
      </div>
    </v-layout>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Info from '@/components/hr/info.vue'
import EmployeeSkillBox from '@/components/hr/employee-skill-box.vue'

export default {
  components: {
    EmployeeSkillBox
  },
  created: function() {
    this.loading = true
    this.$store.dispatch('skills/getAllGlobal').finally(() => {
      this.loading = false
    })
    this.$store.dispatch('colorCategories/getAll')
  },
  computed: {
    globalSkillsAvailable: function() {
      return this.$store.state.skills.globalSkills;
    },
    employeesActiveSkills: function() {
      return this.$store.state.employees.detailedEmployee.global_skills
    },
  },
  props: [
    'employee'
  ],
  data: function() {
    return {
      loading: false,
      newSkillDialog: false,
      apiCallPending: false,
      skillName: '',
      skillLocal: false,
      deletingSkills: false,
      deleteSkillDialog: false,
      deleteDialogItem: {},
    }
  },
  methods: {
    createSkill () {
      this.apiCallPending = true
      this.$store.dispatch('skills/create', { name: this.skillName, global: true, user_id: this.employee.id }).finally(res => {
        this.apiCallPending = false
        this.newSkillDialog = false
        this.skillName = ''
        this.skillLocal = false
      })
    },
    openDeleteModal (skill) {
      this.deleteDialogItem = skill
      this.deleteSkillDialog = true
    },
    toggleDeleteSkills () {
      this.deletingSkills = !this.deletingSkills;
    },
    deleteSkill (skill) {
      this.$store.dispatch('skills/destroy', skill.id).finally(res => {
        // in case the current employee had this skill, update:
        this.$store.dispatch('employees/getEmployee', this.employee.id)
        this.apiCallPending = false
        this.deleteSkillDialog = false
      })
    },
  },
}
</script>

<style scoped>
  .removing .v-label {
    color: white !important;
  }
  span.v-chip {
    cursor: pointer;
  }
</style>
